"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _errorTypes = _interopRequireDefault(require("./lib/errorTypes"));

var _marked = /*#__PURE__*/_regenerator["default"].mark(loadData),
    _marked2 = /*#__PURE__*/_regenerator["default"].mark(deleteData);

function loadData(_ref) {
  var actions, query, queryName, queryVariable, _ref$errorMessage, errorMessage, _ref$ignoreLoading, ignoreLoading, res;

  return _regenerator["default"].wrap(function loadData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          actions = _ref.actions, query = _ref.query, queryName = _ref.queryName, queryVariable = _ref.queryVariable, _ref$errorMessage = _ref.errorMessage, errorMessage = _ref$errorMessage === void 0 ? "Unable to load data" : _ref$errorMessage, _ref$ignoreLoading = _ref.ignoreLoading, ignoreLoading = _ref$ignoreLoading === void 0 ? false : _ref$ignoreLoading;
          _context.prev = 1;

          if (ignoreLoading) {
            _context.next = 5;
            break;
          }

          _context.next = 5;
          return (0, _effects.put)(actions.updateLoading(true));

        case 5:
          _context.next = 7;
          return (0, _effects.call)(query, queryVariable);

        case 7:
          res = _context.sent;

          if (!res.data[queryName]) {
            _context.next = 16;
            break;
          }

          _context.next = 11;
          return (0, _effects.put)(actions.updateData(res.data[queryName]));

        case 11:
          _context.next = 13;
          return (0, _effects.put)(actions.updateError(false));

        case 13:
          if (ignoreLoading) {
            _context.next = 16;
            break;
          }

          _context.next = 16;
          return (0, _effects.put)(actions.updateLoading(false));

        case 16:
          _context.next = 27;
          break;

        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](1);
          console.log(_context.t0);
          _context.next = 23;
          return (0, _effects.put)(actions.updateError({
            type: _errorTypes["default"].noData,
            message: errorMessage
          }));

        case 23:
          if (ignoreLoading) {
            _context.next = 26;
            break;
          }

          _context.next = 26;
          return (0, _effects.put)(actions.updateLoading(false));

        case 26:
          if (typeof window !== "undefined" && window.hj) {
            window.hj("tagRecording", ["[WFB][General] Error loading data"]);
          }

        case 27:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 18]]);
}

function deleteData(_ref2) {
  var actions, query, loadDataQuery, loadDataQueryName, queryName, notificationsActions, queryVariable, _ref2$errorMessage, errorMessage, _ref2$loadDataErrorMe, loadDataErrorMessage, res;

  return _regenerator["default"].wrap(function deleteData$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          actions = _ref2.actions, query = _ref2.query, loadDataQuery = _ref2.loadDataQuery, loadDataQueryName = _ref2.loadDataQueryName, queryName = _ref2.queryName, notificationsActions = _ref2.notificationsActions, queryVariable = _ref2.queryVariable, _ref2$errorMessage = _ref2.errorMessage, errorMessage = _ref2$errorMessage === void 0 ? "There was a problem deleting this data" : _ref2$errorMessage, _ref2$loadDataErrorMe = _ref2.loadDataErrorMessage, loadDataErrorMessage = _ref2$loadDataErrorMe === void 0 ? "Error loading data" : _ref2$loadDataErrorMe;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.call)(query, queryVariable);

        case 4:
          res = _context2.sent;

          if (!res.data[queryName]) {
            _context2.next = 10;
            break;
          }

          _context2.next = 8;
          return (0, _effects.call)(function () {
            return loadData({
              actions: actions,
              errorMessage: loadDataErrorMessage,
              query: loadDataQuery,
              queryName: loadDataQueryName,
              ignoreLoading: true
            });
          });

        case 8:
          _context2.next = 11;
          break;

        case 10:
          throw new Error();

        case 11:
          _context2.next = 19;
          break;

        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](1);
          console.log(_context2.t0);
          _context2.next = 18;
          return (0, _effects.put)(notificationsActions.addNotification({
            message: errorMessage,
            closable: true
          }));

        case 18:
          if (typeof window !== "undefined" && window.hj) {
            window.hj("tagRecording", ["[WFB][General] Error deleting data"]);
          }

        case 19:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 13]]);
}

var _default = {
  deleteData: deleteData,
  loadData: loadData
};
exports["default"] = _default;